module.exports = {"TXTWCL_There_are_price_updates":{"id":"TXTWCL_There_are_price_updates","defaultMessage":"Es liegen geänderte Quoten vor"}}